import { useSelector } from "react-redux";

import AddGuests from "@components/Booking/AddGuest/AddGuest";
import Pricing from "@components/Booking/BookingForm/Pricing/Pricing";
import { BookingFetchResponseType } from "@models/services/booking";
import { RootState } from "@store/index";

const BookingDrawerStepTwo = ({
  allowBringGuest,
  bookingSlots,
  guestError,
  payment,
}: {
  payment: {
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: (paymentMethod: string) => void;
  };
  bookingSlots: BookingFetchResponseType;
  guestError: string;
  allowBringGuest: boolean;
}) => {
  const { guestList, selectedSlot, selectedTime } = useSelector(
    (State: RootState) => State.booking
  );
  return (
    <>
      {selectedTime !== "" &&
        Object.keys(selectedSlot || {}).length > 0 &&
        selectedSlot?.isBookable &&
        !(!allowBringGuest && guestList.length === 0) && (
          <AddGuests slotInfo={bookingSlots} guestError={guestError} />
        )}
      <Pricing
        payment={{
          selectedPaymentMethod: payment.selectedPaymentMethod,
          setSelectedPaymentMethod: payment.setSelectedPaymentMethod,
        }}
        isFromDrawer={true}
      />
    </>
  );
};

export default BookingDrawerStepTwo;
